import { render, staticRenderFns } from "./store-settlement.vue?vue&type=template&id=2dccefdf"
import script from "./store-settlement.vue?vue&type=script&lang=js"
export * from "./store-settlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports